import { CSSProperties } from "react";

export interface ElementOptions {
  className?: string;
  id: string;
  tagName?: string;
  style?: string;
  appendTo?: HTMLElement;
}

export interface SetElementStyleOptions {
  className: string;
  style?: CSSProperties;
}

export interface DomEvent {
  name: string;
  action: () => void;
}

export interface createHtmlComponentInterface {
  zIndex: number | undefined;
  styleObject: CSSProperties;
  id: string;
  className: string;
  appendTo?: HTMLElement | undefined;
  actions?: DomEvent[] | undefined;
}

export function createHtmlComponent({
  zIndex,
  styleObject,
  className,
  appendTo,
  actions,
  id
}: createHtmlComponentInterface): HTMLElement {
  if (zIndex) {
    styleObject.zIndex = zIndex;
  }
  const elementStyle = jsObjectToCssString(styleObject);
  const element = getOrCreateDomElement({
    style: elementStyle,
    className,
    appendTo,
    id
  });
  actions &&
    actions.forEach(action => {
      element.addEventListener(action.name, action.action);
    });
  return element;
}

export function getOrCreateDomElement({ className, style, appendTo, id , tagName}: ElementOptions): HTMLElement {
  const root = appendTo ? appendTo : document.getElementsByTagName('body')[0];

  let element = document.getElementById(id) as HTMLElement;

  if (!element) {
    element = document.createElement(tagName || 'div');
    element.id = id;
    root.appendChild(element);
  }
  className && (element.className = className);
  style && element.style && (element.style.cssText = style);

  return element;
}

export function setElementStyle(element: HTMLElement, { className, style }: SetElementStyleOptions) {
  className && (element.className = className);
  style && element.style && (element.style.cssText = jsObjectToCssString(style));
}

export function jsObjectToCssString(style: object): string {
  // convert object to style
  let styleString = Object.entries(style).reduce((styleString, [propName, propValue]) => {
    return `${styleString}${propName}:${propValue};`;
  }, '');

  // convert kebab case (zIndex -> z-index)
  styleString = styleString.replace(/([A-Z])/g, matches => `-${matches[0].toLowerCase()}`);

  return styleString;
}
